import './App.css';
import React, { useContext } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

import { BrcContext } from './BrcContextWrapper';
import NavBar from './components/NavBar.js';
import Campaigns from './pages/Campaigns';
import Questions from './pages/Questions';
import Answers from './pages/Answers';
import Login from './pages/Login';
import Reports from './pages/Reports';
import { VERSION } from './config/global.js';

function App() {
  const { sessionUser } = useContext(BrcContext);

  return (
    <div className="App">
      <NavBar user={sessionUser} />
      <BrowserRouter>
        <Routes>
          <Route path="Login" element={<Login />}></Route>
          <Route index element={<Campaigns />} />
          <Route path="Questions" element={<Questions />}></Route>
          <Route path="Answers" element={<Answers />}></Route>
          <Route path="Reports" element={<Reports />}></Route>
        </Routes>
      </BrowserRouter>
      <footer className="fixed-bottom bg-light text-secondary">
        <small>Brand Lift Study Dashboard (v{VERSION})</small>
      </footer>
    </div>
  );
}

export default App;
